import * as Yup from 'yup';

export const getTimesheetSchema = (isClientOptional: boolean) =>
  Yup.object().shape({
    id: Yup.number().optional().notRequired(),
    client_id: isClientOptional
      ? Yup.string().optional().notRequired().nullable()
      : Yup.number().required().min(0),
    provider_name: Yup.string().optional().notRequired(),
    service_code_id: Yup.number().required().min(0),
    date_start: Yup.string().required(),
    date_end: Yup.string().required(),
    label: Yup.string()
      .min(60)
      .required('Description is required and must be at least 60 characters'),
    utc_offset: Yup.number().required(),
    client_name: Yup.string().optional().notRequired(),
    service_code: Yup.string().optional().notRequired(),
    read_only: Yup.boolean().optional().notRequired(),
    pay_period: Yup.string().optional().notRequired(),
  });
